import React, { FunctionComponent } from 'react';
import styles from './promo-section.module.scss';
import { INDENT_IN_PARAGRAPH } from '../../const/text-decorators/text-decorators';
import { ThemeVariantType } from '../../typings';

export interface IPromoSectionProps {
  text: IPromoSection;
  themeVariant?: ThemeVariantType;
  backgroundAsset?: string;
  textParameters?: string[];
}

export const PromoSection: FunctionComponent<IPromoSectionProps> = props => {
  const theme = props.themeVariant || 'primary';
  const indentCheck =
    Array.isArray(props.textParameters) &&
    props.textParameters.filter(item => item === INDENT_IN_PARAGRAPH).length ===
      1
      ? true
      : null;

  return (
    <div data-theme={`theme-${theme}`} className={styles.sectionContainer}>
      <div
        className={styles.sectionStyle}
        style={{
          backgroundImage: `url(${
            props.backgroundAsset ? props.backgroundAsset : null
          })`
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: props.text }}
          className={`${styles.text} ${
            indentCheck ? styles.indentInParagraph : ''
          }`}
        />
      </div>
    </div>
  );
};
